@if (institutionId > 0) {
    <div
        id="submodule-opportunities"
        class="cw-module-card">
        <div class="cw-flex-row">
            <h2>{{ 'GLOBAL.MENU.OPPORTUNITIES' | translate }}</h2>
        </div>

        <phscw-grid-new
            [gridName]="gridName"
            [gridDataBackendUrl]="gridDataBackendUrl"
            [displayedColumnsName]="displayedColumnsName"
            [routerBasePath]="routerBasePath"
            [enableCheckboxSelection]="false"
            [entityName]="entityName"
            [gridFilter]="gridFilter"
            [initialSort]="initialSort"
            [enableRowClickHandler]="false"
            [isSearchRelevantForGrid]="false">
        </phscw-grid-new>
    </div>
}
